<template>
    <v-col cols="12" sm="12" class="px-0 py-0">
        <v-carousel
            class="home-banner"
            hide-delimiters
            show-arrows-on-hover
            :show-arrows="banners.length > 1"
        >
            <v-carousel-item
                v-for="banner in banners"
                :key="banner.id"
                :active-class="'home-banner__' + banner.key"
            >
                <v-container class="app-container home-banner__container d-flex flex-column align-center justify-center">
                    <div class="d-flex flex-column align-center">
                        <h1 class="text-uppercase text-center white--text home-banner__title">{{ banner.main_text }}</h1>
                        <p class="ma-0 py-7 text-center white--text home-banner__subtitle"
                           :class="{'subtitle-1': $vuetify.breakpoint.xsOnly, 'title': $vuetify.breakpoint.smAndUp}"
                        >{{ banner.sub_text }}</p>

                        <smart-search
                            filled
                            rounded
                            use-inner-prepend-icon
                            class="home-banner__search"
                            color="grey darken-1"
                            background-color="white"
                            :placeholder="$t('siteSearchBanner')"
                        ></smart-search>
                    </div>

                    <i class="home-banner__arrow" @click="$emit('arrow-click')"></i>
                </v-container>
            </v-carousel-item>
        </v-carousel>
    </v-col>
</template>

<script>
    import SmartSearch from '../../../app-front/components/smart-search/SmartSearch';

    export default {
        name: 'HomeBanner',
        components: {
            SmartSearch
        },
        computed: {
            banners() {
                return this.$store.state.baseInfo.banners;
            }
        },
    }
</script>

<style scoped>

</style>
